/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Qr_Open_ButtonInputs */

const vi_payment_qr_open_button = /** @type {(inputs: Payment_Qr_Open_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán QR`)
};

/**

* @param {Payment_Qr_Open_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_qr_open_button = /** @type {((inputs?: Payment_Qr_Open_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Qr_Open_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_qr_open_button(inputs)
});